import { type PageableRes } from '../types/common';

export const makePageableResult = <T>(
  prevState: PageableRes<T[]> | undefined,
  nextState: Partial<PageableRes<T[]>>
): PageableRes<T[]> => {
  const {
    content = [],
    pageable = {
      number: 0,
      size: 0,
      total: 0,
      last: true,
      count: 0,
    },
  } = nextState;

  const prevPage = prevState?.pageable.number ?? 0;
  const nextPage = nextState.pageable?.number ?? 0;

  const shouldReplace = !prevState || prevPage >= nextPage;

  const fetchedCategory = shouldReplace
    ? { content, pageable }
    : {
        content: [...(prevState?.content ?? []), ...(content ?? [])] as T[],
        pageable,
      };

  return fetchedCategory;
};
